import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess240001Status: 'idle',
    startProcess240001Error: undefined as any,
    loadUserParamsProcess240001Status: 'idle',
    loadUserParamsProcess240001Error: undefined as any,
    buchIni_IsProjektRueckstellungActiveStatus: 'idle',
    buchIni_IsProjektRueckstellungActiveError: undefined as any,

    process240001List: [] as any[],
    buchIni_IsProjektRueckstellungActive: undefined as any,
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess240001 = createAsyncThunk('process240001Slice/startProcess240001', async ({ process240001 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess240001/`,
        prepareData(process240001),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess240001Status } = getState().process240001Slice
        return startProcess240001Status !== 'pending'
    }
})

export const loadUserParamsProcess240001 = createAsyncThunk('process240001Slice/loadUserParamsProcess240001', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess240001/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess240001Status } = getState().process240001Slice
        return loadUserParamsProcess240001Status !== 'pending'
    }
})

export const buchIni_IsProjektRueckstellungActive = createAsyncThunk('process240001Slice/buchIni_IsProjektRueckstellungActive', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/BuchIni_IsProjektRueckstellungActive/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { buchIni_IsProjektRueckstellungActiveStatus } = getState().process240001Slice
        return buchIni_IsProjektRueckstellungActiveStatus !== 'pending'
    }
})

const Process240001Slice = createSlice({
    name: 'process240001Slice',
    initialState,
    reducers: {
        resetstartProcess240001: (state) => {
            state.job = undefined
            state.startProcess240001Error = undefined
        },
        resetstartProcess240001Error: (state) => {
            state.startProcess240001Error = undefined
        },
        resetloadUserParamsProcess240001: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess240001Error = undefined
        },
        resetloadUserParamsProcess240001Error: (state) => {
            state.loadUserParamsProcess240001Error = undefined
        },
        resetbuchIni_IsProjektRueckstellungActive: (state) => {
            state.buchIni_IsProjektRueckstellungActive = undefined
            state.buchIni_IsProjektRueckstellungActiveError = undefined
        },
        resetbuchIni_IsProjektRueckstellungActiveError: (state) => {
            state.buchIni_IsProjektRueckstellungActiveError = undefined
        },
        removeFromProcess240001ListById: (state, action) => {
            state.process240001List = state.process240001List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess240001ListByIds: (state, action) => {
            state.process240001List = state.process240001List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process240001List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess240001Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process240001List = []
            state.startProcess240001Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess240001.pending, (state) => {
            state.startProcess240001Status = 'pending'
            state.startProcess240001Error = undefined
        })
        builder.addCase(startProcess240001.fulfilled, (state, action) => {
            state.startProcess240001Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess240001.rejected, (state, action) => {
            state.startProcess240001Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess240001Error = action.error.message
            } else {
                state.startProcess240001Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess240001.pending, (state) => {
            state.loadUserParamsProcess240001Status = 'pending'
            state.loadUserParamsProcess240001Error = undefined
        })
        builder.addCase(loadUserParamsProcess240001.fulfilled, (state, action) => {
            state.loadUserParamsProcess240001Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess240001.rejected, (state, action) => {
            state.loadUserParamsProcess240001Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess240001Error = action.error.message
            } else {
                state.loadUserParamsProcess240001Error = action.payload
            }
        })

        builder.addCase(buchIni_IsProjektRueckstellungActive.pending, (state) => {
            state.buchIni_IsProjektRueckstellungActiveStatus = 'pending'
            state.buchIni_IsProjektRueckstellungActiveError = undefined
        })
        builder.addCase(buchIni_IsProjektRueckstellungActive.fulfilled, (state, action) => {
            state.buchIni_IsProjektRueckstellungActiveStatus = 'idle'

            {
                state.buchIni_IsProjektRueckstellungActive = action.payload

            }
        })
        builder.addCase(buchIni_IsProjektRueckstellungActive.rejected, (state, action) => {
            state.buchIni_IsProjektRueckstellungActiveStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.buchIni_IsProjektRueckstellungActiveError = action.error.message
            } else {
                state.buchIni_IsProjektRueckstellungActiveError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess240001,
    resetstartProcess240001Error,
    resetloadUserParamsProcess240001,
    resetloadUserParamsProcess240001Error,
    resetbuchIni_IsProjektRueckstellungActive,
    resetbuchIni_IsProjektRueckstellungActiveError,
    removeFromProcess240001ListById,
    removeFromProcess240001ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process240001Slice.actions
export default Process240001Slice.reducer
